module.exports = __webpack_public_path__ + "static/media/add-friend.4a6799c2.svg";